import React, { useState, useEffect } from 'react';
import { Table, Flex, Button } from 'antd';

import { TableCol } from './getTableCol';

import { courseStruct } from './struct';
import { getRandomId } from '../../../../../../utilities/randomId';
import { semesterLabel } from '../../../../../../const/semesterLabel';

const { table, actionSection } = courseStruct;

export const Course = ({ courses, semesterName, updateSemester, apaPoint, status }) => {

  const [_courses, setCourses] = useState(courses?.length > 0 ? courses : []);
  const handleCourses = (courses) => setCourses(courses);

  const handleAdd = () => {
    if (_courses?.length >= 1) return;
    const newPlaning = {
      key: getRandomId(),
      number_of_sessions: 0,
      modal: []
    };
    handleCourses([..._courses, newPlaning]);
  };

  const handleSave = (row) => {
    const currentCourses = [..._courses];
    const index = currentCourses.findIndex((item) => item.key === row.key);

    currentCourses[index] = {
      ...currentCourses[index],
      ...row,
      modal: row.modal
    };


    handleCourses(currentCourses);
  };



  const columns = [
    ...TableCol(handleSave, semesterName, status)
  ];

  useEffect(() => {
    updateSemester(semesterName, _courses);
  }, [_courses, semesterName]);

  return courses ? (
    <>
      <Table
        {...table}
        columns={columns}
        dataSource={_courses}
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell colSpan={1} align='right' >
              Calculated APA score for the {semesterLabel(semesterName)} semester:
            </Table.Summary.Cell>
            <Table.Summary.Cell >{apaPoint}</Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
      <br />

      {
        _courses.length < 1 &&
        <Flex {...actionSection}>
          <Button className="glow-btn" disabled={status === 1 || status === 2 || status === 3} onClick={handleAdd}>Add New Item</Button>
        </Flex>
      }
    </>
  ) : (
    <></>
  );
};
